import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { useFormattedBookingDetails } from 'reservations/booking/hooks/useFormattedBookingDetails';

const DinerInformationReadOnlyField = styled(Typography)({ fontSize: '16px' });

const DinerInformationReadOnlyModify = () => {
  const { email, formattedPhone, fullName } = useFormattedBookingDetails();
  const readOnlyFields = [email, fullName, formattedPhone].map(field => (
    <DinerInformationReadOnlyField key={field}>
      {field}
    </DinerInformationReadOnlyField>
  ));

  return <>{readOnlyFields}</>;
};

export default DinerInformationReadOnlyModify;
